import { useCallback } from 'react'
import { HardwareSupplierFilterKeyType } from '../pages/ordering/type'
import useCityPlumbingService from './cityPlumbing/useCityPlumbingService'

export const useDistributorConnect = () => {
  const cityPlumbingService = useCityPlumbingService()

  return useCallback((distributor?: HardwareSupplierFilterKeyType) => {
    if (distributor === 'city_plumbing') {
      return cityPlumbingService.connect()
    }

    console.warn(`No connect implementation for distributor: ${distributor}`)
  }, [])
}
